import { useRef, useState, useEffect } from 'react'
import s from './ViewMore.module.scss'
import cn from 'classnames'

const DIV_HEIGHT = 81

type ReadMoreProps = {
    className?: string
    children: JSX.Element
}

export const ViewMore = ({ className, children }: ReadMoreProps) => {
    const showMoreRef = useRef<HTMLDivElement>(null)
    const messageHtml = showMoreRef.current
    const [showReadMore, setShowReadMore] = useState(true)
    const [showButton, setShowButton] = useState(false)
    useEffect(() => {
        if (messageHtml && !showButton) {
            const divHeight = messageHtml?.offsetHeight
            if (divHeight && divHeight > DIV_HEIGHT) setShowButton(true)
        }
    }, [messageHtml])

    const handleButton = () => {
        setShowReadMore(!showReadMore)
    }

    if (!children) return null

    return (
        <div>
            <div
                className={cn(
                    className,
                    showButton && showReadMore
                        ? s['read-more-message-hide']
                        : s['less-pdp-msg']
                )}
                ref={showMoreRef}
            >
                {children}
            </div>
            {showButton && (
                <button
                    className={cn(
                        s['read-more-button'],
                        'btn-link pdp-read-more'
                    )}
                    onClick={handleButton}
                >
                    {showReadMore ? 'View More' : 'View Less'}
                </button>
            )}
        </div>
    )
}
